import { render, staticRenderFns } from "./SFileUploadEditor.vue?vue&type=template&id=3008e360&"
import script from "./SFileUploadEditor.vue?vue&type=script&lang=js&"
export * from "./SFileUploadEditor.vue?vue&type=script&lang=js&"
import style0 from "./SFileUploadEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports